import React, { useEffect, useState } from 'react'

// Components
import ReleaseNotesModal from './ReleaseNotesModal'

// Utils
import useReleaseNotes from '../../hooks/useReleaseNotes'

// Syncs the member's release-notes state and opens the newest note once per
// session when it is unread. Mounted by AppLayout on pages with the navbar only.
const ReleaseNotesPopup: React.FC = () => {
  const { notes, autoOpen, markAutoOpened } = useReleaseNotes(true)
  const [noteId, setNoteId] = useState<string>()

  useEffect(() => {
    if (!autoOpen) return
    markAutoOpened()
    setNoteId(notes[0].id)
  }, [autoOpen])

  return noteId ? (
    <ReleaseNotesModal
      initialNoteId={noteId}
      closeModal={() => setNoteId(undefined)}
    />
  ) : null
}

export default ReleaseNotesPopup
